import { useMutation } from '@/hooks/use-api';
import registerUserApi from '@/api/post/register-user';
import Alert from '@/components/alert/alert-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { Heading1Text } from '@/utils/global-fonts';
import { useNavigate, useParams } from 'react-router-dom';
import CompleteRegistrationForm from './complete-registration-form';

/**
 * Complete Registration page.
 * @returns {JSX.Element} The rendered CompleteRegistration page.
 */
const CompleteRegistration = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [registerUser, { loading: registerUserLoading }] =
    useMutation(registerUserApi);

  return (
    <PageWrapper>
      <Heading1Text>Complete Registration</Heading1Text>
      <FormWrapper
        defaultValues={{
          email: '',
          password: '',
          confirmPassword: '',
          termsAndConditions: false,
        }}
        onSubmit={(formData) =>
          registerUser(id, formData)
            .then(() => {
              Alert({
                icon: 'success',
                text: 'Register user successful',
              });
              navigate('/login');
            })
            .catch((error) => {
              Alert({
                icon: 'error',
                text: error.response.data.message,
              });
            })
        }
      >
        <CompleteRegistrationForm loading={registerUserLoading} />
      </FormWrapper>
    </PageWrapper>
  );
};

export default CompleteRegistration;
